import { Component, OnInit,Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '../../../../../node_modules/@angular/forms';
@Component({
  selector: 'modal-finalizar-matricula',
  templateUrl: './modal-finalizar-matricula.component.html',
  styleUrls: ['./modal-finalizar-matricula.component.css']
})
export class ModalFinalizarMatriculaComponent implements OnInit {
  @Input() fromAlumno : FormBuilder
  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-finalizar-matricula/modal-finalizar-matricula.component.ts